<section class="container-section" *ngIf="!isOpened">
  <div class="row mx-0">
    <form class="container-style" novalidate [formGroup]="formInternalOrder">
      <div class="ps-2 pe-2">
        <div class="row pt-1">
          <div class="col">
            <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
              [width]="'6rem'" routerLink="/internal-order" [severity]="null"></app-custom-button>
          </div>
          <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
            <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
          </div>

          <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
            <app-custom-button [title]="'Eliminar'" [severity]="'contrast'" [icon]="'pi pi-trash'"
              (onClick)="deleteInternalOrder()"></app-custom-button>
            <app-custom-button [title]="'Imprimir'" [severity]="'contrast'" [icon]="'pi pi-print'"
              (onClick)="printPage()"></app-custom-button>

            <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'" [width]="'5.5rem'"
              [severity]="'success'" [variant]="undefined" (onClick)="createNewInternalOrder()"></app-custom-button>
          </div>
          <hr class="my-1">
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <app-custom-audit-info [userNameCreate]="internalOrderContract.userNameCreate"
              [createDate]="internalOrderContract.createDate" [userNameUpdate]="internalOrderContract.userNameUpdate"
              [updateDate]="internalOrderContract.updateDate"
              [reserveSpace]="true"></app-custom-audit-info>
          </div>
        </div>
        <div class="row mt-1 d-flex justify-content-between">
          <div class="col-lg-12 mb-2">
            <div class="row">
              <div class="col field-branch">
                <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranches"
                  [required]="true" [recovery]="true" (onChangeSelect)="getBranch($event, true)"></app-custom-select>
              </div>
              <div class="col field-consecutive">
                <app-custom-input-number formControlName="consecutive" [labelText]="'Número'" [required]="true"
                  [recovery]="true" (onChangeNumber)="changeConsecutive()"></app-custom-input-number>
              </div>
              <div class="col field-consecutive">
                <app-custom-input-number formControlName="alterNumber"
                  [labelText]="'Número Alt.'"></app-custom-input-number>
              </div>
              <div class="col field-date-internal-order">
                <app-custom-datepicker formControlName="dateInternalOrder" [labelText]="'Fecha'"
                  [required]="true"></app-custom-datepicker>
              </div>
              <div class="col field-responsible">
                <app-custom-input-text formControlName="responsible" [required]="true" [labelText]="'Responsable'"
                  [maxLength]="250"></app-custom-input-text>
              </div>
              <div class="col field-state ps-lg-5 ps-1">
                <app-custom-tag [label]="'Estado'" [value]="stateText"
                  [severity]="internalOrderContract.internalOrderState === stateOpen ? 'danger' : ''">
                </app-custom-tag>
              </div>
              <div class="col-lg-2 col-md-4 col-sm-2 col-6 d-flex align-items-center gap-2 ">
                <div class="m-top">
                  <div class="d-flex gap-1">
                    <app-custom-button [icon]="iconState" [title]="titleState" [severity]="'primary'"
                      (onClick)="changeState()"></app-custom-button>
                  </div>
                </div>
                <div class="m-top">
                  <div class="d-flex gap-1">
                    <app-custom-button [title]="'Anular'" [severity]="'danger'" [icon]="'pi pi-ban'"
                      (onClick)="annulInternalOrder()"></app-custom-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" [hidden]="!swManagesInventoryOfSupplies">
              <div class="col field-om-class">
                <app-custom-select formControlName="maintenanceOrderClass" [labelText]="'Clase OM'"
                  [list]="listClassMaintenanceOrder" [recovery]="true" (onChangeSelect)="changeMaintenanceOrderClass()">
                </app-custom-select>
              </div>
              <div class="col field-om-number">
                <app-custom-input-number formControlName="maintenanceOrderConsecutive" [labelText]="'Nro. OM'"
                  [recovery]="true" (onChangeNumber)="changeMaintenanceOrderConsecutive()">
                </app-custom-input-number>
              </div>
              <div class="col field-om-equipment">
                <app-custom-input-text [value]="articleCodeName" [labelText]="'Equipo'"
                  [disabled]="true"></app-custom-input-text>
              </div>
            </div>
            <div class="row">
              <div class="col field-observation">
                <app-custom-textarea formControlName="observation" [labelText]="'Observación'" [rows]="1"
                  [autoResize]="false" [maxLength]="250"></app-custom-textarea>
              </div>
              <div class="col field-save">
                <app-custom-button [label]="'Guardar'" [severity]="'primary'" [variant]="undefined"
                  (onClick)="send()"></app-custom-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="container-style mt-2">
    <app-internal-order-detail [disabledDetail]="disabledDetail" [internalOrderModel]="internalOrderContract"
      [quantityDetails]="quantityDetails" [disabledActions]="disabledActions" [swQuotation]="swQuotation && swManagesInventoryOfSupplies"
      (emitQuantityDetails)="updateQuantityDetails($event)">
    </app-internal-order-detail>
  </div>
</section>

<app-print-internal-order id="print-internal-order" [companyId]="companyId" [formatModel]="formatModel"
  [internalOrderModel]="internalOrderPrintModel" [editFormat]="false" [focusText]="false"
  (finishLoadingPrint)="finishLoading($event)">
</app-print-internal-order>

<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>